import { render, staticRenderFns } from "./IVRWelcomeGreetingmodal.vue?vue&type=template&id=118fa198&"
import script from "./IVRWelcomeGreetingmodal.vue?vue&type=script&lang=js&"
export * from "./IVRWelcomeGreetingmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports